import React from 'react';
import cx from 'classnames';
import {priority} from '@priority-software/priority-proto-api/lib/nform';
import {getStatusBorderColor} from './utils';
import styles from './styles.module.scss';

export const StatusIcon = (props: {
    status: string;
    isRtl?: boolean;
    statuses: priority.netitems.form.IStatus[];
}) => {
    const {status, isRtl, statuses} = props;

    const statusData = statuses.find(item => item.Statdes === status) || {};
    const borderColor = getStatusBorderColor(statusData.Color);

    return (
        <div
            className={cx(styles.component, {[styles.rtlMargin]: isRtl})}
            style={{borderColor, backgroundColor: statusData.Color}}
        />
    );
};
